import { IFaireIcon } from '@faire/web-api--source/indigofair/data/IFaireIcon';

export namespace IButtonUIElement {
  export enum ButtonVariant {
    BUTTON_VARIANT_UNKNOWN = 'BUTTON_VARIANT_UNKNOWN',
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    TERTIARY = 'TERTIARY',
    PLAIN = 'PLAIN',
  }

  export enum ButtonIconPosition {
    BUTTON_ICON_POSITION_UNKNOWN = 'BUTTON_ICON_POSITION_UNKNOWN',
    START = 'START',
    END = 'END',
  }

  export enum ButtonSize {
    BUTTON_SIZE_UNKNOWN = 'BUTTON_SIZE_UNKNOWN',
    MEDIUM = 'MEDIUM',
    SMALL = 'SMALL',
  }

  /**
   * Return an instance of IButtonUIElement with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IButtonUIElement>
  ): IButtonUIElement =>
    ({
      ...(partial ?? {}),
    }) as IButtonUIElement;
}

export interface IButtonUIElement {
  variant: keyof typeof IButtonUIElement.ButtonVariant | undefined;
  label: string | undefined;
  icon_position: keyof typeof IButtonUIElement.ButtonIconPosition | undefined;
  destructive: boolean | undefined;
  /**
   * Used for accessibility purposes, describes what the button will do in the component.
   */
  content_description: string | undefined;
  icon: IFaireIcon | undefined;
  size: keyof typeof IButtonUIElement.ButtonSize | undefined;
}
